import {WidgetDatasourceEnum} from "./widget-datasource.enum";
import {WidgetTypeEnum} from "./widget-type.enum";

export const DashboardWidgetConfigurationEnum = {
  [WidgetDatasourceEnum.servicesStatusTotals]: {
    [WidgetTypeEnum.PieChartWidget]: {
      cols: 4,
      rows: 6,
    },
    [WidgetTypeEnum.NumberWidget]: {
      cols: 4,
      rows: 5,
    }
  },
  [WidgetDatasourceEnum.agentsStatusTotal]: {
    [WidgetTypeEnum.PieChartWidget]: {
      cols: 4,
      rows: 6,
    },
    [WidgetTypeEnum.NumberWidget]: {
      cols: 4,
      rows: 5,
    }
  },
  [WidgetDatasourceEnum.ordersStatusTotal]: {
    [WidgetTypeEnum.PieChartWidget]: {
      cols: 4,
      rows: 6,
    },
    [WidgetTypeEnum.NumberWidget]: {
      cols: 4,
      rows: 5,
    }
  },
  [WidgetDatasourceEnum.ordersTotal]: {
    [WidgetTypeEnum.NumberWidget]: {
      cols: 4,
      rows: 5,
    }
  },
  [WidgetDatasourceEnum.agentsTracking]: {
    [WidgetTypeEnum.TableWidget]: {
      cols: 4,
      rows: 10,
      loadLimit: 15,
      maxItemRows: 20,
    }
  },
  [WidgetDatasourceEnum.agentsLocations]: {
    [WidgetTypeEnum.MapWidget]: {
      cols: 4,
      rows: 12,
    }
  },
  [WidgetDatasourceEnum.totalRoutesScore]: {
    [WidgetTypeEnum.MetricsAverageWidget]: {
      cols: 3,
      rows: 6,
    }
  },
  [WidgetDatasourceEnum.agentsRoutesScore]: {
    [WidgetTypeEnum.TableWidget]: {
      cols: 4,
      rows: 10,
      loadLimit: 15,
      maxItemRows: 20,
    }
  },
}
